export default "__VITE_ASSET__f0c39a75__"